import KoButton from 'packages/button';
import KoTable from 'packages/datatable';
import KoIcon from '@kwapio/icons';
import KoModal from 'packages/modal';
import {KoPagination} from 'packages/pagination';
import KoTooltips from 'packages/tooltips';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getCookie } from 'shared/utils/cookies';
import KoTicketTable_COLUMNS from './constant';
import KoToolBar from './toolbar';
import { getTicketBreadCrumb } from 'shared/commonConstants';
import { KoBadge, KoText, KoTitle, KoToast } from 'packages';
import moment from 'moment';
import BulkUpdateCrud from './bulkUpdate';
const KoTicketTable = (props) => {

  const { tickets,maxHeight,workspaceId, form, pagination, onPagination,
    totalCount, setModal, onSearchText, setDueModal, extraColumnsRight,
    setCommnetsModal,isToolbar=true,
    showSizeChanger,
    profile, title, onChangeStatus, onChangeType, isLoading,
    currentRecord, setCurrentRecord, onChangePriority, setBreadCrumbs,
    onChangeAssignees,
    onChangeReporter,
    onChangeComponent,
    onChangeModule,
    API, getTicketsList, setLoading, GetChild,
    columns, onSort, createBtn,
    getIssueById, onExtraClick, onCellClickExternal,
    isExport,
    isImport,
    isEpic,
    refreshData,
    RowSelectionOption: {
      visible: rowSelectionVisible
    },
    Bulk: {
      visible: bulkVisible
    },
    dueDate = {
      visible: false
    },
    onRowSelection,
    rowKey
  } = props;


  
  const [copy, setCopy] = useState(false);
  const [selectedTickets, setSelectedTickets] = useState();
  const [isBulkModal, setBulkModal] = useState(false);
  const [isOpenBulkConfirm, setBulkConfirmModal] = useState(false);
  const [isBulkDelete, setBulkDeleteModal] = useState(false);
  

  const OnRowSelection=(ticketId)=>{
    setSelectedTickets(ticketId);
    onRowSelection && onRowSelection(ticketId);
  };

  
  const bulkUpdate =(values)=>{
    values['ticketId'] = selectedTickets;
    setLoading(true);
    API.BulkUpdateIssue(values, workspaceId).then(
      (data) => {
        setLoading(false);
        setBulkModal(false);
        setBulkConfirmModal(false);
        getTicketsList();
      },
      (err) => {
        setLoading(false);
      }
      
    );
  };

  const bulkDelete =()=>{

    let obj={
    };

    if(isEpic){
      obj['epicIds'] = selectedTickets;
    }else{
      obj['ticketId'] = selectedTickets;
    }
    setLoading(true);
    API.bulkDelete(obj, workspaceId, isEpic).then(
      (data) => {
        setLoading(false);
        setBulkDeleteModal(false);
        getTicketsList();
        KoToast.success("Ticket deleted successfully");
      },
      (err) => {
        setLoading(false);
      }
      
    );
  };

  const onCopyTicket=(row)=>{
    setCopy(true);
    navigator.clipboard.writeText(`${window.location.origin}/open/ticket/${getCookie("accountId")}/${row?.workspace}/${row?.ticketId}`);
  };

  const columnsRight = [{
	  title: '',
	  dataIndex: 'x',
	  key: 'x',
	  fixed: 'right',
	  width: 40,
	  render: (text, row) => {
	    return <div className={` tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        <KoTooltips title={'Comments'}>
          <KoBadge count={row?.commentsCount} >
            <KoButton onClick={() => setCommnetsModal(true)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'ChatOutlined'} />} />
          </KoBadge>
        </KoTooltips>
        <KoTooltips title={copy ? 'Copied' : 'Copy'}>
	      <KoButton onClick={()=>onCopyTicket(row)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'CopyOutlined'}/>}/>
        </KoTooltips>
        <KoTooltips title={'New window'}>
          <Link target="_blank" to={`/open/ticket/${getCookie("accountId")}/${row?.workspace}/${row?.ticketId}`}>
            <KoButton className={'btn'}  iconBtn={true} icon={<KoIcon width={14} height={14} name={'OpenOutlined'}/>}/>
          </Link>
        </KoTooltips>
	    </div>;
	  }
  }];

  const onCellClick = (row, action) => {
    if(action === 'epicId') {
      getIssueById(row);
      return;
    }
    const updatedRoomObj = { ...row, source: 'tickets' };
    // dispatch(setSelectedChatData(updatedRoomObj));
    // dispatch(setSelectedChatType('tickets'));
    if (setBreadCrumbs) {
      let crumbs = getTicketBreadCrumb(updatedRoomObj);
      setBreadCrumbs(crumbs);
    }
    if (GetChild) {
      setCurrentRecord(updatedRoomObj);
      GetChild(updatedRoomObj);
    } else {
      getIssueById(updatedRoomObj?.ticketId || row?.epeicId);
      setModal(true);
    }
  };

  const handleExport = async() => {
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_PROXY_HOST}/api/v1/taskplanner/ticket/export`, {
        method: "GET",
        headers: {
          "Content-Type": "text/csv",
          Authorization: `Bearer ${getCookie("accessToken")}`,
          "workspace": workspaceId
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch CSV: ${response.statusText}`);
      }

        // Convert response to Blob
      const csvData = await response.blob();
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

        // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "ticket_" + moment().format("YYYY-MM-DD") + ".csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      {isToolbar && <KoToolBar
        title={title}
        onChangeStatus={onChangeStatus}
        onChangeType={onChangeType}
        onChangePriority={onChangePriority}
        isEpic={isEpic}
        onChangeAssignees={onChangeAssignees}
        onChangeReporter={onChangeReporter}
        onChangeComponent={onChangeComponent}
        onChangeModule={onChangeModule}
        isImport={isImport}
        isExport={isExport}
        handleExport={handleExport}
        Bulk={{
          visible: bulkVisible ? bulkVisible : false,
          open: isBulkModal,
          setBulkModal: setBulkModal,
          setBulkConfirmModal: setBulkConfirmModal,
          handleOk: () => {setBulkModal(!isBulkModal); form?.resetFields();},
          handleCancel: () => {setBulkModal(!isBulkModal); form?.resetFields();},
          form: form,
          onSubmit: (values) => {bulkUpdate(values);},
          onCancel: () => {setBulkModal(!isBulkModal); form?.resetFields();},
          selectedTickets: selectedTickets
        }}
        profile={profile}
        search={{ visible: true, onChange: onSearchText, placeholder: 'Ex: Summary / Ticket Id' }}
        filter={
          { visible: false,
            label:'Status',
            options: [{ label: 'Sort By Name', key: '0' }, { label: 'Sort By Roles', key: '1' }, { label: 'Created At', key: '2' }, { label: 'Sort By designation', key: '3' }] }}
        buttonList={[
          ...(dueDate?.visible ? [{
            label: 'Overdue',
            type: 'primary',
            color: "danger",
            variant: "filled",
            onClick: () => { setDueModal(true); setBreadCrumbs(); }
          }] : []),
          ...(createBtn ? [{
            label: 'Create',
            type: 'primary',
            icon: <KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />,
            onClick: () => setModal(true)
          }] : []),
          {
            label: 'Delete',
            color: "danger",
            variant: "filled",
            disable: selectedTickets?.length === 0,
            icon: <KoIcon name="DeleteOutlined" width={18} height={18} />,
            onClick: () => setBulkDeleteModal(true)
          }
        ]}

      />}
      <KoTable rowKey={rowKey ? rowKey : 'ticketId'}
        maxHeight={maxHeight ? maxHeight : 125}
        onSort={onSort}
        isEpic={isEpic}
        refreshData={refreshData && refreshData}
        onExtraClick={onExtraClick && onExtraClick}
        onRowSelection={rowSelectionVisible && OnRowSelection}
        onCellClick={onCellClickExternal? onCellClickExternal : onCellClick}
        data={{ columns:columns ? columns : KoTicketTable_COLUMNS, rows: tickets }}
        extraColumnsRight={extraColumnsRight? extraColumnsRight : columnsRight}
      />
      
      {
        pagination && <KoPagination current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.limit}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showSizeChanger={showSizeChanger}
          showQuickJumper={false}
          simple={false}
          responsive={false} />
      }

      <KoModal
        title={`Bulk Update`}
        centered
        open={isBulkModal}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setBulkModal(false); form?.resetFields();}}
        onClose={() => { setCurrentRecord(); setBulkModal(false); form?.resetFields();}}
        width={780}
        // maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setBulkModal(!isBulkModal); form?.resetFields();}} />,
          <KoButton key='update' loading={isLoading} type='primary' label={ `Update`}
            onClick={() => setBulkConfirmModal(true)} />
        ]}
      >
        <BulkUpdateCrud initialValues={currentRecord} form={form} setBulkConfirmModal={setBulkConfirmModal} bulkUpdate={bulkUpdate} profile={profile} API={API} />
      </KoModal>

      <KoModal
        title={`Confirmation`}
        centered
        open={isOpenBulkConfirm}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setBulkConfirmModal(false); }}
        onClose={() => { setCurrentRecord(); setBulkConfirmModal(false); }}
        width={580}
      // maskClosable={false}
        height={450}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setBulkConfirmModal(!isOpenBulkConfirm)} />,
          <KoButton key='proceed' loading={isLoading} type='primary' label='Proceed' onClick={() => form.submit()} />
        ]}
      >
        <div>
          <KoTitle level={5} text={`Are you sure you want to proceed with this bulk update?`} />
          <KoText text={`This action will apply changes to multiple users and may affect their data and associated permissions. Please review carefully before proceeding.`} />
        </div>
      </KoModal>

      <KoModal
        title={`Delete Confirmation`}
        centered
        open={isBulkDelete}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setBulkDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setBulkDeleteModal(false); }}
        width={580}
        height={450}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setBulkDeleteModal(false)} />,
          <KoButton key='proceed' loading={isLoading} type='primary' label='Proceed' onClick={() => bulkDelete()} />
        ]}
      >
        <div>
          <KoTitle level={5} text={`Are you sure you want to delete these selected tickets/issues?`} />
          <KoText text={`This action will permanently remove them and may affect related data or user visibility. Please review carefully before proceeding.`} />
        </div>
      </KoModal>
    </>
  );
};

export default KoTicketTable;


